export const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '10px', // Width of the scrollbar
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888', // Color of the scrollbar handle
    borderRadius: '5px', // Rounded corners
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1', // Color of the scrollbar track
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#555', // Darker color when hovered
  },
};

export const packageClasses = [
  'Geometry',
  'Algebra',
  'Physics',
  'Calculus',
  'Biology',
  'Chemistry',
  'Computer Science',
  'History',
  'Literature',
  'Social Studies',
  'Foreign Language',
];

export const listViewMapping = {
  savedNotes: {
    heading: 'My Notes',
    subHeading: 'Saved Notes',
    retrieveEventName: 'getSavedNotes',
    deleteEventName: 'deleteNotes',
  },

  savedQuizzes: {
    heading: 'My Quizzes',
    subHeading: 'Quizzes',
    retrieveEventName: 'getSavedQuizzes',
    deleteEventName: 'deleteQuiz',
  },
};

export const explainFurtherPrompt = `You will be helping a student better understand a concept from their school notes by 
providing a detailed explanation of a piece of text they have highlighted.

Please carefully read through the highlighted text. Then, write a detailed explanation that:

1) Identifies and elaborates on the key points and main ideas in the text
2) Provides additional context, details and examples to help clarify the concept(s) being discussed
3) Simplifies and breaks down any complex terms or ideas
4) Makes connections to related concepts the student may have learned

The goal is to help the student develop a thorough understanding of what is being taught in the highlighted portion of their notes.

Here is the text the student highlighted from their notes:

`;

export const simplifyFurtherPrompt = `You will be simplifying a piece of text that a student has highlighted from their school notes. 
Your goal is to rewrite the highlighted text in a way that is easier to understand, using simple language and clear explanations.
First, carefully read through the highlighted text to make sure you fully understand the concepts and information it is conveying.

Then, consider the following:

- What simpler terms or language could you use to explain the same ideas?
- Are there any comparisons to more common, relatable topics you could make to help illustrate difficult concepts?
- How can you explain any complex terminology or jargon the text uses?
- Can you break down any long, complicated sentences into shorter, clearer statements?

Once you have a clear plan, rewrite the highlighted text in simplified form. Use plain language and straightforward sentence structure. 
When helpful, include analogies or comparisons to more familiar
ideas to aid understanding. Define any technical terms that may be unfamiliar.

Here is the text the student highlighted from their notes:

`;

export const summarizeFurtherPrompt = `Your task is to summarize the key points from a piece of text that a student has highlighted from their notes. 
I will provide the highlighted text, and you will identify the most important information and concisely summarize it.

Please read the highlighted text carefully. Identify and extract only the key points, main ideas, 
and crucial details that are most essential to understanding the meaning and purpose of the text.
Minor details and examples that are not absolutely necessary should be excluded.

Concisely summarize the key points you identified in a few bullet points. The summary should 
be significantly shorter than the original highlighted text, while still clearly conveying the most important information.
Focus on brevity and clarity.
The summary should be in BULLET POINT format, spaced out. 

Here is the text the student highlighted from their notes:
`;

export const provideExamplesPrompt = `You are an AI tutor helping a student study from their notes. 
The student has highlighted a portion of their notes that they think contains important examples related to the main ideas. 
Your task is to identify and extract the key examples from what they highlighted.

Please read the highlighted text carefully. Then, think step-by-step
about how to identify the most important examples in the text:

1. Reread the highlighted text and look for any specific examples, case studies, stories, scenarios,
 or illustrations you can use to add to the concept
2. Consider how each example relates to or supports the main ideas or arguments of the text.
3. Prioritize examples that seem especially relevant, insightful, or memorable
4. Select the top 2-3 examples to extract and share with the student.

Now, extract the key examples you identified and write them out inside 'Examples' heading:

Make sure to only use examples directly related to the text. Do not 
make up or invent any examples that aren't real or factual.

Finally, write a response inside 'Answer' heading that summarizes the examples you chose and explains how they relate to the main ideas of the text:
Here is the text the student highlighted from their notes:

`;
